import uuid from 'uuid-random';
import { addPopupAction, LAYER } from '@theme/js/components/common/PopupManager';
import { CookiesRegulationPopup } from '../CookiesRegulationPopup';

const cookiesRegulationPopupId: string = uuid();

export const showCookiesRegulationPopupAction = () => addPopupAction({
    isModal: true,
    id: cookiesRegulationPopupId,
    layer: LAYER.COOKIE_REGULATION_POPUP,
    component: CookiesRegulationPopup
});
